export const radii = {
    tile: {
        value: '0.625rem',
    },
};
